export class ListMicrosoft365GroupMembersRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "search",
            "baseName": "search",
            "type": "string",
            "format": ""
        },
        {
            "name": "sort",
            "baseName": "sort",
            "type": "ListMicrosoft365GroupMembersSort",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMicrosoft365GroupMembersRequest.attributeTypeMap;
    }
    constructor() {
    }
}
